﻿import { Component, Output, EventEmitter, ViewChild, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { PagerService } from '../..//./services/pager.service';
import { HttpService } from '../..//./services/http.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FollowupModel } from "./..//../models/followup.model";

@Component({
    selector: 'user-follow-up',
    templateUrl: './user-followup.component.html',
    providers: [PagerService, HttpService]
})
export class UserFollowupComponent implements OnInit, OnChanges {
    @ViewChild('followupForm') public myForm: NgForm;
    @Input("user-id") UserId: number = 0;
    @Input("create") create: number = 0;
    id: number = 0;
    isDelete: boolean = false;
    searchString: string = "";
    isAddEdit: boolean = false;
    pagerSize: number = 10;
    start: number = 1;
    end: number = this.pagerSize + this.start - 1;
    data: any[] = [];
    keys: any[] = [];
    pageNo: number = 1;
    pager: any = {};
    dataCount: number = 0;
    pagerSizes: any[] = [
        { "Text": "5", "Value": 5 }, { "Text": "10", "Value": 10 }, { "Text": "25", "Value": 25 }, { "Text": "50", "Value": 50 }, { "Text": "All", "Value": 0 }
    ];
    orderBy: any = "Id";
    isDescending: boolean = true;
    isLoader: boolean = false;
    socialMedia: any = [];
    users: any = [];
    columns: any = [];
    api: any = { Search: "Followup/Search", Find: "Followup/Find", Delete: "Followup/Delete", Save: "Followup/Save", "SocialMedia": "usersocialmedia/lookup", "Users": "userdetail/lookup" }
    permission: any = { Add: true, Edit: true, Delete: true };
    todayDate: any = new Date();
    obj: FollowupModel = new FollowupModel();
    isSubmitted: boolean = false;
    isSaveLoader: boolean = false;
    constructor(public http: HttpService, public pagerService: PagerService, public toastr: ToastrService) {
        this.columns = [
            { Name: "FollowUpProcess", Header: "Through", DataType: "string" },
            { Name: "FollowUpThrough", Header: "Connect", DataType: "string" },
            { Name: "FollowUpNote", Header: "Note", DataType: "string" },
            { Name: "FollowUpDate", Header: "Date", DataType: "string" },
            { Name: "FollowUpStatus", Header: "Status", DataType: "string" },
            { Name: "FollowUpRemarks", Header: "Remarks", DataType: "string" }
        ];
        this.isDelete = false;
        this.isAddEdit = false;
        this.id = 0;
        if (this.myForm) {
            this.myForm.reset();
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.create.currentValue != changes.create.previousValue && parseInt(changes.create.currentValue) > 0) {
            this.edit(0);
        }
    }
    ngOnInit(): void {
        if (!this.columns) {
            this.columns = [];
        }
        this.bindUsers();
        this.loadData();
    }

    changePager(): void {
        this.pageNo = 1;
        this.loadData();
    }

    loadData(): void {
        this.start = (this.pageNo - 1) * this.pagerSize;
        this.end = this.pageNo * this.pagerSize;
        let objSearch = {
            SearchString: this.searchString, RecordsPerPage: this.pagerSize, OrderBy: this.orderBy, IsDecending: this.isDescending, PageNo: this.pageNo, Id: this.UserId
        };
        this.isLoader = true;
        this.http.post("" + this.api.Search, objSearch).subscribe(result => {
            this.data = result.json().List;
            this.dataCount = result.json().NoOfRecords;
            this.pager = this.pagerService.getPager(this.dataCount, this.pageNo, this.pagerSize);
            this.isLoader = false;

        }, error => {
            this.isLoader = false;
            this.http.validateAuth(error);
        });

    }


    sort(column: string) {
        if (this.orderBy == column) {
            this.isDescending = !this.isDescending;
        }
        else {
            this.isDescending = false;
        }
        this.orderBy = column;
        this.pageNo = 1;
        this.loadData();
    }

    setPage(page: number) {
        this.pageNo = page;
        this.loadData();

    }

    search() {
        this.pageNo = 1;
        this.loadData();
    }

    edit(Id: number) {
        this.find(Id);
        this.isAddEdit = true;
    }
    deleteConfirm(Id: number) {
        this.id = Id;
        this.isDelete = true;
    }
    delete() {
        this.http.post("" + this.api.Delete, { "Id": this.id }).subscribe(result => {
            this.closeModal();
            this.loadData();
        }, error => {
            console.error(error);
        });
    }

    closeModal() {
        this.isDelete = false;
        this.isAddEdit = false;
        this.id = 0;
    }


    clear() {
        this.isSubmitted = false;
        this.isSaveLoader = false;
        if (this.myForm) {
            this.myForm.reset();
        }
        this.obj = new FollowupModel();
        this.obj.UserId = this.UserId;
    }

    find(Id: number) {
        this.obj = new FollowupModel();
        console.log(Id);
        this.obj.Id = Id;
        this.obj.UserId = this.UserId;
        if (Id > 0) {
            this.http.post("" + this.api.Find, { Id: Id }).subscribe(result => {
                if (!result.json().IsFailure) {
                    this.obj = result.json();
                }
                this.isLoader = false;
            }, error => {
                this.isLoader = false;
                this.http.validateAuth(error);
            });
        }
    }

    save() {
        this.isSubmitted = true;
        if (this.myForm.valid) {
            this.obj.UserId = this.UserId;
            this.isSaveLoader = true;
            this.http.post("" + this.api.Save, this.obj).subscribe(result => {
                if (result.json().IsFailure) {
                    this.toastr.error('Failed!', result.json().Message);
                }
                else {
                    this.toastr.success('Success!', result.json().Message);
                    //this.clear();
                    this.loadData();
                    this.closeModal();
                }
                this.isSaveLoader = false;
            }, error => {
                this.isSaveLoader = false;
                this.http.validateAuth(error);
            });
        }
    }

    bindUsers() {
        this.http.post("" + this.api.Users).subscribe(result => {
            this.users = result.json();
            this.obj.UserId = this.UserId;
            this.bindSocialMedia();
        }, error => {
            this.http.validateAuth(error);
        });
    }

    bindUserStatus() {
        if (this.obj.UserId > 0) {
            for (let i = 0; i < this.users.length; i++) {
                if (this.users[i].Id == this.obj.UserId) {
                    this.obj.UserStatus = this.users[i].UserStatus;
                }
            }
        }
    }

    bindSocialMedia() {
        if (this.obj.UserId > 0) {
            this.http.post("" + this.api.SocialMedia).subscribe(result => {
                this.socialMedia = result.json();
                this.bindThrough();
                this.bindUserStatus();
            }, error => {
                this.http.validateAuth(error);
            });
        }
    }

    bindThrough() {
        if (this.obj.FollowUpProcess != "") {
            if (this.obj.FollowUpProcess == "Primary Email")
            {
                for (let i = 0; i < this.users.length; i++) {
                    if (this.users[i].Id == this.obj.UserId) {
                        this.obj.FollowUpThrough = this.users[i].PrimaryEmail;
                        break;
                    }
                }
            }
            else if (this.obj.FollowUpProcess == "Secondary Email") {
                for (let i = 0; i < this.users.length; i++) {
                    if (this.users[i].Id == this.obj.UserId) {
                        this.obj.FollowUpThrough = this.users[i].SecondaryEmail;
                        break;
                    }
                }
            }
            else if (this.obj.FollowUpProcess == "Primary Phone") {
                for (let i = 0; i < this.users.length; i++) {
                    if (this.users[i].Id == this.obj.UserId) {
                        this.obj.FollowUpThrough = this.users[i].PrimaryContactNo;
                        break;
                    }
                }
            }
            else if (this.obj.FollowUpProcess == "Secondary Phone") {
                for (let i = 0; i < this.users.length; i++) {
                    if (this.users[i].Id == this.obj.UserId) {
                        this.obj.FollowUpThrough = this.users[i].SecondaryContactNo;
                        break;
                    }
                }
            }
            else {
                for (let i = 0; i < this.socialMedia.length; i++) {
                    if (this.socialMedia[i].AppName == this.obj.FollowUpProcess) {
                        this.obj.FollowUpThrough = this.socialMedia[i].Url;
                        break;
                    }
                }
            }
            
        }
    }
}